import classNames from 'classnames';
import styles from './ai-record-background.module.less';

export interface IChatListBackground extends React.HTMLAttributes<HTMLDivElement> { }

/**
 * 聊天列表的背景容器，必须是reletive定位
 */
export const ChatListBackground: React.FC<IChatListBackground> = ({
  className, children, ...otherProps
}) => {
  const newClassName = classNames(styles.aiRecordBackgroundWrapper, className);

  return (
    <div className={newClassName} {...otherProps}>
      <div className={classNames(styles.aiRecordBackgroundConic, styles.aiRecordBackgroundItem1)} />
      <div className={classNames(styles.aiRecordBackgroundConic, styles.aiRecordBackgroundItem2)} />
      <div className={classNames(styles.aiRecordBackgroundConic, styles.aiRecordBackgroundItem3)} />
      {children}
    </div>
  );
};
